
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.125 0C.515 0-.001.512-.001 1.122v15.753C0 17.485.516 18 1.125 18h15.75a1.14 1.14 0 001.126-1.125V1.123c0-.61-.517-1.122-1.126-1.122zm.953 2.077h13.846v13.846H2.078z"}}),_c('path',{attrs:{"d":"M5.383 6.748a.83.83 0 00-.592 1.42l3.624 3.62a.83.83 0 001.173 0l3.622-3.62a.83.83 0 00-.59-1.42zm2.003 1.665h3.225l-1.612 1.613z"}})])
          )
        }
      }
    